document.addEventListener("DOMContentLoaded", function() {
  // 슬라이드 이미지 영역이 있는지 확인
  const swiperContainer = document.querySelector('.add-img-swiper');
  if (!swiperContainer) return;

  // Swiper 초기화
  const swiper = new Swiper(swiperContainer, {
    loop: false,
    slidesPerView: 1,
    navigation: {
      nextEl: '.custom-next',
      prevEl: '.custom-prev'
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      hide: false
    },
    breakpoints: {
      1280: { slidesPerView: 2.3 },
      860:  { slidesPerView: 1.2 }
    }
  });

  // 마우스 휠 이벤트로 가로 스크롤 구현
  let accumulatedDeltaY = 0;
  const scrollThreshold = 100; // 임계값

  swiperContainer.addEventListener('wheel', function(event) {
    accumulatedDeltaY += event.deltaY;
    if (accumulatedDeltaY > scrollThreshold) {
      swiper.slideNext();
      accumulatedDeltaY = 0;
    } else if (accumulatedDeltaY < -scrollThreshold) {
      swiper.slidePrev();
      accumulatedDeltaY = 0;
    }
    event.preventDefault(); // 기본 스크롤 방지
  }, { passive: false });

  // 추가: Swiper 영역 밖의 휠 이벤트는 기본 스크롤 허용
  document.addEventListener('wheel', function(event) {
    if (!swiperContainer.contains(event.target)) {
      return;
    }
  });
});
